<template lang="pug">
  div(v-click-outside="hide")
    .select-choice-modal(@click="stopPropagation" :class="{'select-choice-modal-area': user.has_basic && user.search_city_ai}")
      .select-choice-modal-title 市を選択する
      .area-support-box(v-if="user.has_basic && user.search_city_ai")
        p 市区町村を選択する
        input.text-box(type="text" v-model="areaText" placeholder="例）横浜市")
        .button-check-area(v-if="isLoading")
          input.button-check.disabled(type="button" value="チェック中・・・" :disabled="true")
        .button-check-area(v-else)
          input.button-check(type="button" value="チェック" @click="recommendCity" :class="{ disabled: !activateAreaCheckButton }")
      .select-choice-modal-sidebar(:class="{'select-choice-modal-area-sidebar': user.has_basic && user.search_city_ai}")
        ul
          li(
            v-for="option in prefectures"
            :value="option.code"
            :class="isActive(option.code) ? 'active' : ''"
          )
            a(@click="selectPrefecture(option.code)") {{ option.name }}
              template(v-if="isActive(option.code)")
                span.label-selected 選択中
      .select-choice-modal-main.select-choice-modal-main-area
        p.check-all
          label.checkbox
            input(type="checkbox" v-model="allChecked" @click="checkAll")
            span すべて
        p
          label.checkbox(v-for="city in displayCities")
            input(type="checkbox" :value="city.code" v-model="cityCd")
            span {{ city.name }}
        p.select-choice-modal-button
          input.button-main(type="button" value="設定する" @click="submit")
    .modal-cover(@click="hide")
</template>

<script>
  import { mapState } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import { api } from '../../libs/api'

  export default {
    directives: { ClickOutside },
    props: [
      'groupingPrefecture',
      'openPrefectureCityModal',
      'selectedCityCd',
      'selectedPrefectureCd',
      'prefectures',
    ],
    mounted () {
      this.popupItem = this.$el
    },
    data () {
      return {
        allChecked: false,
        displayCities: [],
        prefectureCode: 0,
        prefectureCodes: new Set(),
        cityCd: [],
        areaText: '',
        isLoading: false,
      }
    },
    computed: {
      ...mapState({
        cities: state => state.master.cities.concat({ code: '99', name: 'その他', prefecture_cd: 99 }),
        user: state => state.user.detail,
      }),
      activateAreaCheckButton () {
        if (this.areaText === '') {
          return false
        }
        return true
      },
    },
    watch: {
      openPrefectureCityModal () {
        this.selectPrefecture(this.prefectures[0].code)
        if (this.groupingPrefecture) {
          // すべて選択している市区町村を都道府県CDとして扱う仕組み
          // 都道府県CD(selectedPrefectureCd)を渡された場合は、当該都道府県のcityCdを全て選択状態にする
          const cityCdValues = this.selectedCityCd.map(c => c.value)
          const prefectureCdValues = this.selectedPrefectureCd.map(c => c.value)

          let tmpCityCd = this.cities.filter(c => cityCdValues.indexOf(c.code) >= 0)
          const allSelectCities = this.cities.filter(c =>
            prefectureCdValues.indexOf(c.prefecture_cd) >= 0,
          )
          tmpCityCd = tmpCityCd.concat(allSelectCities)
          this.cityCd = tmpCityCd.map(c => c.code)
        } else {
          this.cityCd = this.selectedCityCd.map(j => j.value)
        }
      },
      cityCd () {
        const cities = this.cityCd.map(c => this.cities.find(j => j.code === c))

        this.prefectureCodes = new Set(cities.map(j => j.prefecture_cd))
        this.setAllCheck()
      },
    },
    methods: {
      checkAll (e) {
        const codes = this.displayCities.map(j => j.code)
        if (e.currentTarget.checked) {
          this.cityCd = [...new Set(this.cityCd.concat(codes))]
        } else {
          this.cityCd = this.cityCd.filter(c => !codes.includes(c))
        }
      },
      stopPropagation (e) {
        e.stopPropagation()
      },
      isActive (prefectureCode) {
        return this.prefectureCodes.has(prefectureCode)
      },
      selectPrefecture (prefectureCode) {
        this.prefectureCode = prefectureCode
        this.displayCities = this.cities.filter(j => j.prefecture_cd === prefectureCode)
        this.setAllCheck()
      },
      setAllCheck () {
        const displaySelectedCount = this.displayCities.filter(j =>
          this.cityCd.includes(j.code)).length
        const displayCitiesCount = this.displayCities.length
        this.allChecked =
          displayCitiesCount !== 0 && displayCitiesCount === displaySelectedCount
      },
      submit () {
        if (this.groupingPrefecture) {
          // すべて選択している市区町村を都道府県CDとして扱う仕組み
          let cities = this.cityCd.map(c => this.cities.find(d => d.code === c))
          const groupedAllCities = this.cities.reduce((groups, item) => {
            const key = item.prefecture_cd
            // eslint-disable-next-line
            groups[key] = groups[key] || []
            groups[key].push(item)
            return groups
          }, {})
          const groupedCities = cities.reduce((groups, item) => {
            const key = item.prefecture_cd
            // eslint-disable-next-line
            groups[key] = groups[key] || []
            groups[key].push(item)
            return groups
          }, {})

          const prefectures = []
          const prefectureCodes = []
          Object.keys(groupedCities).forEach((key) => {
            if (groupedCities[key].length === groupedAllCities[key].length) {
              // 全て市区町村選択している県
              const intKey = parseInt(key, 10)
              const prefecture = this.prefectures.find(p => p.code === intKey)
              prefectures.push({ label: prefecture.name, value: prefecture.code })
              prefectureCodes.push(intKey)
            }
          })
          this.$emit('setPrefectures', prefectures)

          cities = cities.filter(c => prefectureCodes.indexOf(c.prefecture_cd) < 0)
          const cityCd = cities.map(j => ({ label: j.name, value: j.code }))
          this.$emit('setPrefectureCities', cityCd)
        } else {
          const cities = this.cityCd.map(c => this.cities.find(j => j.code === c))
          const cityCd = cities.map(j => ({ label: j.name, value: j.code }))
          this.$emit('setPrefectureCities', cityCd)
        }
      },
      hide () {
        this.$emit('hide')
      },
      async recommendCity () {
        this.$store.commit('common/lockGlobal')
        try {
          this.isLoading = true
          const result = await api.getAreaAi(this.areaText)
          this.cityCd = this.cityCd.concat(result[this.areaText])

          this.isLoading = false
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
          this.isLoading = false
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/PrefectureCityModal.vue